// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".widget--messages-widget-news-item .detail-link{display:block;color:#fa0019;text-decoration:none}.widget--messages-widget-news-item .detail-link:hover{text-decoration:underline}", ""]);
// Exports
module.exports = exports;
